import React from "react";

import _ from "lodash";

import { useUiExtenderContext } from "commons/context/uiExtender";

function useUiExtenderPull({ key }: { key: string }) {
    const uiElements = useUiExtenderContext();

    return React.useMemo(() => {
        if (key in uiElements) {
            return (
                <React.Fragment>
                    {_.orderBy(uiElements[key], "priority", "asc").map((item) => (
                        <React.Fragment key={item.id}>{item.element}</React.Fragment>
                    ))}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }, [uiElements, key]);
}

export default useUiExtenderPull;
